import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const ORE_ROCK = "#534f4a";
const ORE_VEIN = "#b9893f";

function rockUnit(cx: number, cy: number, cz: number, s: number, c: string, vein?: string): Part[] {
  const out: Part[] = [{ geometry: new THREE.IcosahedronGeometry(s, 0), color: c, position: [cx, cy, cz], scale: [1, 0.8, 0.92] as const }];
  if (vein) out.push({ geometry: new THREE.IcosahedronGeometry(s * 0.34, 0), color: vein, position: [cx + s * 0.3, cy + s * 0.2, cz - s * 0.2] });
  return out;
}

export const oreChunk = defineModel({
  id: "ore-chunk",
  batchId: "characters",
  name: "Ore chunk",
  tags: ["good", "cargo", "ore"],
  fits: ["carry"],
  summary: "A chunk of ore with gold veins -- a carriable good for an avatar's carry socket.",
  description:
    "Two ore rocks with vein highlights at held scale, ported from age-of-mcp's " +
    "goods (`ore`). Mount it in a player's or worker's `carry` socket to show " +
    "the figure hauling ore.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: (): Part[] => [
    ...rockUnit(0, 0.05, 0.01, 0.07, ORE_ROCK, ORE_VEIN),
    ...rockUnit(0.045, 0.032, 0.02, 0.04, ORE_ROCK, ORE_VEIN),
  ],
  animations: [],
});
